import {
  BrowserRouter,
  Route,
  Routes,
  Navigate
} from 'react-router-dom'

import {
  Layout,
  Home,
  Download,
  Features,
  FAQ,
  ReleaseNotes,
  ThankYou,
  Error404,
  TermsOfUse,
  Impressum,
  Partners,
  Contact,
  ScrollToTop,
  CookieConsentBanner,
  PrivacyPolicy,
  LanguageRedirect,
  defaultLanguage,
  AnalyticsTracker,
  loadGA4
} from './components';

import {
  PluginList,
  NotesPlugin,
  PriceListsPlugin,
  SaudiArabiaEInvoicePlugin,
  MyLogoPlugin,
  PrintStationsPlugin,
  NamedOrderPlugin,
  StockControlPlugin,
  EmailReportingPlugin,
  MrpPlugin,
  DualCurrencyPlugin,
  FatooraPlugin,
  ExpirationDatePlugin,
  TakeawayPlugin,
  VsmsPlugin,
} from './components/plugins';

function App() {

  function RedirectWithLang({ to }) {
    // Redirect to the requested page with language prefix.
    return <Navigate to={`/${defaultLanguage()}/${to}`} replace />;
  }

  const pluginRedirects = [
    "price-lists",
    "stock-control",
    "my-logo",
    "dual-currency",
    "e-invoice-ksa",
    "print-stations",
    "notes",
    "named-order",
    "email-reporting",
    "mrp",
    "fatoora",
    "expiration-date",
    "vsms"
  ];

  return (
    <BrowserRouter>
      <LanguageRedirect />
      <ScrollToTop />
      <CookieConsentBanner
        onConsentChange={(accepted) => {
          if (accepted) {
            loadGA4();
          }
        }}
      />
      <AnalyticsTracker />
      <Routes>
        {/* Redirect root to default language (English) */}
        <Route path="/" element={<Navigate to={`/${defaultLanguage()}`} />} />

        {/* Redirect plugins to default language */}
        {pluginRedirects.map((plugin) => (
          <Route
            key={plugin}
            path={`/plugins/${plugin}`}
            element={<RedirectWithLang to={`plugins/${plugin}`} />}
          />
        ))}

        <Route path="/:lang" element={<Layout />}>
          <Route index element={<Home />} />
          <Route path="download" element={<Download />} />
          <Route exact path="download/lite" element={<ThankYou version={'Lite'} />} />
          <Route exact path="download/pro" element={<ThankYou version={'Pro'} />} />
          <Route path="plugins">
            <Route index element={<PluginList />} />
            <Route path="dual-currency" element={<DualCurrencyPlugin />} />
            <Route path="price-lists" element={<PriceListsPlugin />} />
            <Route path="e-invoice-ksa" element={<SaudiArabiaEInvoicePlugin />} />
            <Route path="my-logo" element={<MyLogoPlugin />} />
            <Route path="print-stations" element={<PrintStationsPlugin />} />
            <Route path="notes" element={<NotesPlugin />} />
            <Route path="named-order" element={<NamedOrderPlugin />} />
            <Route path="stock-control" element={<StockControlPlugin />} />
            <Route path="email-reporting" element={<EmailReportingPlugin />} />
            <Route path="mrp" element={<MrpPlugin />} />
            <Route path="fatoora" element={<FatooraPlugin />} />
            <Route path="expiration-date" element={<ExpirationDatePlugin />} />
            <Route path="takeaway" element={<TakeawayPlugin />} />
            <Route path="vsms" element={<VsmsPlugin />} />
          </Route>
          <Route path="features" element={<Features />} />
          <Route path="faq" element={<FAQ />} />
          <Route path="release-notes" element={<ReleaseNotes />} />
          <Route path="terms-of-use" element={<TermsOfUse />} />
          <Route path="impressum" element={<Impressum />} />
          <Route path="partners" element={<Partners />} />
          <Route path="contact" element={<Contact />} />
          <Route path="privacy-policy" element={<PrivacyPolicy />} />
          <Route path="*" element={<Error404 />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
